if (typeof DynaCore_Combination == "undefined") {
    var DynaCore_Combination =
    {
        init: function ()
        {
            DynaCore_Combination.groupInit();
            DynaCore_Combination.conditionInit();
            DynaCore_Combination.definitionInit();
        },

        /**
         * Inicializace akci pro podminku
         */
        conditionInit: function ()
        {
            // Podminka - Typ
            $(".combination").off('change', '.combination-condition-type, .combination-condition-typeSource, .combination-condition-typeTarget');
            $(".combination").on('change', '.combination-condition-type, .combination-condition-typeSource, .combination-condition-typeTarget', function () {
                DynaCore_Combination.conditionLoad(this);
            });

            // Podminka - Pridani
            $(".combination").off('click', '.combination-condition-add');
            $(".combination").on('click', '.combination-condition-add', function (e) {
                DynaCore_Combination.conditionAdd(this);

                return false;
            });

            // Podminka - Smazani
            $(".combination").off('click', '.combination-condition-delete');
            $(".combination").on('click', '.combination-condition-delete', function (e) {
                DynaCore_Combination.conditionRemove(this);

                return false;
            });
        },

        /**
         * Pridano bloku podminky
         *
         * @param element
         */
        conditionAdd: function (element)
        {
            // Nacteme si elementy
            var combinationElement = $(element).parents('.combination');
            var groupElement = $(element).parents('.combination-group');

            // Najdeme si potrebna data
            var conditionIndex = $(groupElement).find('.combination-condition').length;
            var groupIndex = $(groupElement).data('group');
            var type = $(combinationElement).data('type');

            // Sestavime posilana data
            var params = {};
            params._ch = $('#_ch').val();
            params.typ = type;
            params.groInd = groupIndex;
            params.conInd = conditionIndex;

            if ('properties' == type) {
                params.pro = $(combinationElement).data('property');
            }

            $.ajax({
                type: 'get',
                url: '/core/combination/condition-add',
                data: params,
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                },
                success: function (response) {
                    $.each(response.messages, function(i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text);
                    });

                    if (true == response.status) {
                        $(groupElement).find('.combination-conditions').append(response.html);

                        DynaCore_Combination.init();
                    }
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        /**
         * Nacteni fieldsetu definice
         *
         * @param element
         */
        conditionLoad: function (element)
        {
            // Nacteme si elementy
            var combinationElement = $(element).parents('.combination');
            var conditionElement = $(element).parents('.combination-condition');

            // Najdeme si potrebna data
            var conditionIndex = $(conditionElement).data('condition');
            var conditionId = $(conditionElement).find('.combination-condition-id').val();
            var conditionType = $(conditionElement).find('.combination-condition-type').val();
            var conditionTypeSource = $(conditionElement).find('.combination-condition-typeSource').val();
            var conditionTypeTarget = $(conditionElement).find('.combination-condition-typeTarget').val();
            var definitionId = $(conditionElement).find('.combination-definition-id').val();
            var groupIndex = $(conditionElement).parents('.combination-group').data('group');
            var property = $(combinationElement).parents('.tab-pane').data('property');
            var type = $(combinationElement).data('type');
            var part = $(combinationElement).data('part');
            var partId = $(combinationElement).data('part-id');
            var subPart = $(combinationElement).data('subpart');
            var subPartId = $(combinationElement).data('subpart-id');
            var target = $('#target').val();
            var targetId = $('#targetId').val();

            // Sestavime posilana data
            var params = {};
            params._ch = $('#_ch').val();
            params.typ = type;
            params.groInd = groupIndex;
            params.conId = conditionId;
            params.conInd = conditionIndex;
            params.conTyp = conditionType;
            params.conTypSou = conditionTypeSource;
            params.conTypTar = conditionTypeTarget;
            params.defId = definitionId;
            params.tar = target;
            params.tarId = targetId;

            if ('filter-conditions' && 'filter-definitions') {
                params.relTar = $('#tab-definition').data('relation-target');
                params.relTarId = $('#tab-definition').data('relation-target-id');
            }

            if ('properties' == type) {
                params.pro = $(combinationElement).data('property');
                params.par = part;
                params.parId = partId;
                params.subPar = subPart;
                params.subParId = subPartId;
            }

            $.ajax({
                type: 'get',
                url: '/core/combination/condition-load',
                data: params,
                dataType: "json",
                success: function (response) {
                    $.each(response.messages, function(i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text);
                    });

                    if (true == response.status) {

                        // Prepiseme aktualni radek
                        $(conditionElement).replaceWith(response.html);

                        DynaCore_Combination.init();
                    }
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        /**
         * Smazani bloku podminky
         *
         * @param element
         */
        conditionRemove: function (element)
        {
            var conditionElement = $(element).parents('.combination-condition');
            var conditionsElement = $(element).parents('.combination-conditions');
            var conditionIndex = $(conditionElement).data('condition');

            // Smazeme operator AND
            if (conditionIndex >= 1) {
                $(conditionElement).prev('.combination-condition-operator').remove();
            }
            if (conditionIndex == 0 && $(conditionsElement).find('.combination-condition').length > 1) {
                $(conditionElement).next('.combination-condition-operator').remove();
            }

            // Smazeme podminku
            $(conditionElement).remove();

            DynaCore_Combination.conditionsReindex();
        },

        /**
         * Preindexuje bloky podminek
         */
        conditionsReindex: function ()
        {
            $('.combination').find('.combination-condition').each(function (i, elementCondition) {
                $(elementCondition).attr('data-condition', i);
                $(elementCondition).find('.combination-condition-number').text(i+1);
            });
        },

        /**
         * Inicializace akci pro opravneni
         */
        definitionInit: function ()
        {
            // Pole - Zmena
            $(".combination").off('change', '.combination-definition-operator, .combination-definition-sourceField, .combination-definition-targetField');
            $(".combination").on('change', '.combination-definition-operator, .combination-definition-sourceField, .combination-definition-targetField', function () {
                var definitionElement = $(this).parents('tr');
                var elementIdForFocus = '#' + $(this).attr('id');

                DynaCore_Combination.definitionLoadFieldset(definitionElement, elementIdForFocus);
            });
        },

        /**
         * Nacteni fieldsetu definice
         *
         * @param definitionElement
         */
        definitionLoadFieldset: function (definitionElement, elementIdForFocus)
        {
            // Nacteme si elementy
            var conditionElement = $(definitionElement).parents('.combination-condition');
            var combinationElement = $(conditionElement).parents('.combination');
            var combinationDefinitionsContainerElement = $(definitionElement).parents('.combination-definitions-container');

            // Najdeme si potrebna data
            var conditionIndex = $(conditionElement).data('condition');
            var definitionIndex = $(definitionElement).data('definition');
            var groupIndex = $(conditionElement).parents('.combination-group').data('group');
            var property = $(conditionElement).parents('.tab-pane').data('property');
            var type = $(combinationElement).data('type');

            var params = $(conditionElement).find(':input').serialize();
            var url = '/core/combination/definition-load?groInd=' + groupIndex + '&conInd=' + conditionIndex + '&defInd=' + definitionIndex + '&typ=' + type;

            if ('properties' == type) {
                url += '&pro=' + $(combinationElement).data('property');
            }

            $.ajax({
                type: 'post',
                url: url,
                data: params,
                dataType: "json",
                success: function (response) {
                    $.each(response.messages, function(i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text);
                    });

                    if (true == response.status) {
                        $(combinationDefinitionsContainerElement).html(response.html);

                        // Nastavime element, ze ktereho bylo kliknuto na aktivni
                        if (typeof (elementIdForFocus) != "undefined") {
                            $(elementIdForFocus).focus();
                        }

                        DynaCore_Combination.init();
                    } else {
                        $(definitionElement).find('.combination-definition-fieldSource').val('');
                        $(definitionElement).find('.combination-definition-fieldTarget').val('');
                    }
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        /**
         * Inicializace akci pro skupinu podminek
         */
        groupInit: function ()
        {
            // Skupina podminek - Pridani
            $(".combination").off('click', '.combination-group-add');
            $(".combination").on('click', '.combination-group-add', function (e) {
                DynaCore_Combination.groupAdd(this);

                return false;
            });

            // Skupina podminek - Smazani
            $(".combination").off('click', '.combination-group-delete');
            $(".combination").on('click', '.combination-group-delete', function (e) {
                DynaCore_Combination.groupRemove(this);

                return false;
            });
        },

        /**
         * Pridano bloku podminky
         *
         * @param element
         */
        groupAdd: function (element)
        {
            // Nacteme si elementy
            var combinationElement = $(element).parents('.combination');
            var groupsElement = $(combinationElement).find('.combination-groups');

            // Nacteme si potrebna data
            var type = $(combinationElement).data('type');
            var groupIndex = $(groupsElement).find('.combination-group').length;

            // Sestavime posilana data
            var params = {};
            params._ch = $('#_ch').val();
            params.typ = type;
            params.groInd = groupIndex;

            if ('properties' == type) {
                params.pro = $(combinationElement).data('property');
            }

            $.ajax({
                type: 'get',
                url: '/core/combination/group-add/',
                data: params,
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                },
                success: function (response) {
                    $.each(response.messages, function(i, message) {
                        Lemo_Alert.build(message.type, message.title, message.text);
                    });

                    if (true == response.status) {
                        $(groupsElement).append(response.html);

                        DynaCore_Combination.init();
                    }
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        /**
         * Smazani bloku skupiny podminek
         *
         * @param element
         */
        groupRemove: function (element)
        {
            // Nacteme si elementy
            var groupElement = $(element).parents('.combination-group');
            var groupsElement = $(groupElement).parents('.combination-groups');

            // Nacteme si potrebna data
            var groupIndex = $(groupElement).data('group');

            // Smazeme operator AND
            if (groupIndex >= 1) {
                $(groupElement).prev('.combination-group-operator').remove();
            }
            if (groupIndex == 0 && $(groupsElement).find('.combination-group').length > 1) {
                $(groupElement).next('.combination-group-operator').remove();
            }

            // Smazeme podminku
            $(groupElement).remove();

            DynaCore_Combination.groupsReindex();
        },

        /**
         * Preindexuje bloky podminek
         */
        groupsReindex: function ()
        {
            $('.combination').find('.combination-group').each(function (i, elementGroup) {
                $(elementGroup).attr('data-group', i);
                $(elementGroup).find('.combination-group-number').text(i+1);
            });
        }
    }
}